import { createContext,useState } from "react";
import { useTranslation } from "react-i18next";
import { ChecklistType } from "../types/checklist/types";
import { ClientType } from "../types/clientes/types";
import { INewFormStore } from "./interfaces/INewFormStore";

export type clienteFormularioType = {
  chamadoObrigatorio: boolean,
  cliente: string,
  delegacao: boolean,
  distanciaLimite: number,
  duracaoValidade: number,
  empresa: string,
  formulario: string,
  gravaPOS: boolean,
  id: string,
  limiteChamado: number,
  qrcode: boolean,
  tipoChamado: number[],
  tipoValidade: null
};

const initalState = {
  modelo: null,
  setModelo: () => { },
  cliente: null,
  setCliente: () => { },
  clienteFormulario: {
    chamadoObrigatorio: false,
    cliente: '',
    delegacao: false,
    distanciaLimite: 0,
    duracaoValidade: 0,
    empresa: '',
    formulario: '',
    gravaPOS: false,
    id: '',
    limiteChamado: 0,
    qrcode: false,
    tipoChamado: [],
    tipoValidade: null
  },
  setClienteFormulario: () => { },
  itemRange: [{
    index: 0,
    name: '',
    range: 100,
  }],
  setItemRange: () => { },
  checkedScoring: false,
  setCheckedScoring: () => { }
};

export const NewFormContext = createContext<INewFormStore>(initalState);
export default function NewFormProvider({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation('translation');
  const [modelo, setModelo] = useState<ChecklistType | null>(null);
  const [cliente, setCliente] = useState<ClientType | null>(null);
  const [checkedScoring, setCheckedScoring] = useState(false);
  const [itemRange, setItemRange] = useState([
    {
      index: 0,
      name: t('formDetails.range_scoring.perfect'),
      range: 100,
    }
  ]);
  const [clienteFormulario, setClienteFormulario] = useState<clienteFormularioType>({
    chamadoObrigatorio: false,
    cliente: "",
    delegacao: false,
    distanciaLimite: 0,
    duracaoValidade: 0,
    empresa: "",
    formulario: "",
    gravaPOS: false,
    id: "",
    limiteChamado: 0,
    qrcode: false,
    tipoChamado: [],
    tipoValidade: null
  });

  const store = {
    modelo,
    setModelo,
    cliente,
    setCliente,
    clienteFormulario,
    setClienteFormulario,
    itemRange,
    setItemRange,
    checkedScoring,
    setCheckedScoring,
  };
  return (
    <NewFormContext.Provider value={store}>
      {children}
    </NewFormContext.Provider>
  );
}